import {setPersistedAtValue} from '../../../actions/atRetirement/persistedAt'

export const atRetirementPersistedAt = (store, next, action) => {
    const result = next(action);
    store.dispatch(setPersistedAtValue());
    return result;
}